<template>
    <section class="p-2 widget my-2">
        <div class="row">
            <div class="col-12">
                <a
                    class="font-weight-bold link-primary float-right text-primary"
                    @click="editContact()"
                    >Add New</a
                >
                <div>
                    <p class="text-uppercase font-weight-bold mb-0">
                        {{ propertyTitle }} information
                    </p>

                    <template v-for="(c, i) in contacts">
                        <div class="d-flex justify-content-between">
                            <div class="w-100">
                                <div class="row mb-0">
                                    <span class="col-6 mb-1">Name:</span>
                                    <span class="col-6 mb-1">{{ c.name }}</span>
                                </div>
                                <div class="row mb-0">
                                    <span class="col-6 mb-1">{{ relationshipPropertyName }}:</span>
                                    <span class="col-6 mb-1">{{ c.relationship }}</span>
                                </div>
                                <div class="row mb-0">
                                    <span class="col-6 mb-1">E-mail:</span>
                                    <span class="col-6 mb-1">{{ c.email }}</span>
                                </div>
                                <div class="row mb-0">
                                    <span class="col-6 mb-1">Phone:</span>
                                    <span class="col-6 mb-1">{{
                                        helpers.formatPhone(c.phone)
                                    }}</span>
                                </div>
                            </div>
                            <div>
                                <template>
                                    <div class="dropdown text-right">
                                        <button
                                            class="btn btn-sm btn-link text-black"
                                            type="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i class="fa fa-ellipsis-v"></i>
                                        </button>
                                        <div
                                            class="dropdown-menu dropdown-menu-right"
                                            aria-labelledby="delete-recurring"
                                        >
                                            <a
                                                class="cursor-pointer dropdown-item small"
                                                @click="editContact(c, i)"
                                                >Edit Contact</a
                                            >
                                            <a
                                                class="cursor-pointer dropdown-item small text-danger"
                                                @click="removeContact(i)"
                                                >Remove Contact</a
                                            >
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <hr v-if="i < contacts.length - 1" class="bar mt-2 mb-3" />
                    </template>
                </div>
            </div>
        </div>
        <modal-component
            :id="contactsProperty"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <form class="p-3">
                <div class="form-group row mb-0">
                    <label for="name1" class="col-6 mb-1">Name:</label>
                    <input
                        id="name1"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.name"
                    />
                </div>
                <div class="form-group row mb-0">
                    <label for="relationship1" class="col-6 mb-1"
                        >{{ relationshipPropertyName }}:</label
                    >
                    <input
                        id="relationship1"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.relationship"
                    />
                </div>
                <div class="form-group row mb-0">
                    <label for="phone1" class="col-6 mb-1">Phone:</label>
                    <input
                        id="phone1"
                        v-mask="'###-###-#### ####'"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.phone"
                    />
                </div>
                <div class="form-group row mb-0">
                    <label for="email1" class="col-6 mb-1">Email:</label>
                    <input
                        id="email1"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.email"
                    />
                </div>

                <div v-show="validationMessage" class="alert alert-danger">
                    <a href="#" class="close" data-dismiss="alert">&times;</a>
                    {{ validationMessage }}
                </div>

                <div class="d-flex justify-content-end">
                    <button
                        class="btn btn-sm btn-primary text-white font-weight-bold text-uppercase"
                        @click.prevent="saveContact()"
                    >
                        Save
                    </button>
                </div>
            </form>
        </modal-component>
    </section>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import { helpers } from "../../plugins/helpers";

export default {
    name: "EmergencyInfoWidget",
    props: ["person", "endpoint", "contactsProperty"],
    components: { ModalComponent },
    data() {
        return {
            helpers,
            modal: {
                visible: false,
                title: null,
            },
            payload: this.generatePayload(),
            editIndex: null,
            contacts: [],
            validationMessage: "",
        };
    },

    watch: {
        person() {
            this.populateContacts();
        },
    },

    mounted() {
        this.populateContacts();
    },

    computed: {
        relationshipPropertyName() {
            switch (this.contactsProperty) {
                case "school_schedule_change_contacts":
                    return "Role";
                default:
                    return "Relationship";
            }
        },

        propertyTitle() {
            switch (this.contactsProperty) {
                case "school_schedule_change_contacts":
                    return "School Schedule Change Contact";
                case "responsible_party_contacts":
                    return "Responsible Party Contact";
                default:
                    return "Emergency Contact";
            }
        },
    },

    methods: {
        populateContacts() {
            this.contacts = this.person[this.contactsProperty]
                ? [...this.person[this.contactsProperty]]
                : [];
        },

        generatePayload() {
            return {
                name: null,
                relationship: null,
                phone: null,
                email: null,
            };
        },

        editContact(contact, index) {
            this.modal.title = contact ? `Edit ${this.propertyTitle}` : `New ${this.propertyTitle}`;
            if (contact) {
                this.editIndex = index;
                Object.keys(this.payload).forEach(k => {
                    this.payload[k] = { ...contact }[k];
                });
            }
            this.modal.visible = true;
        },

        resetModal() {
            this.modal.visible = false;
            this.editIndex = null;
            this.payload = this.generatePayload();
        },

        validatePayload(payload) {
            if (!payload.name) {
                this.validationMessage = `Contact name needs to be filled.`;
                return null;
            }
            if (!payload.relationship) {
                this.validationMessage = `Contact ${this.relationshipPropertyName.toLowerCase()} needs to be filled.`;
                return null;
            }
            if (!payload.phone && !payload.email) {
                this.validationMessage = `Either phone or e-mail need to be filled.`;
                return null;
            }
            payload = helpers.cleanEmptyProperties(payload);
            return payload;
        },

        removeContact(index) {
            let fullPayload = {};
            fullPayload[this.contactsProperty] = [...this.contacts];
            fullPayload[this.contactsProperty].splice(index, 1);
            axios
                .patch(`${this.endpoint}${this.person.id}`, fullPayload)
                .then(r => {
                    this.$emit("person-saved");
                    this.resetModal();
                })
                .catch(e => {
                    console.error(e);
                });
        },

        saveContact() {
            this.validationMessage = null;
            let payload = { ...this.payload };
            payload = this.validatePayload(payload);
            if (!payload) return;
            let contacts = [...this.contacts];
            switch (typeof this.editIndex) {
                case "number":
                    contacts[this.editIndex] = { ...payload };
                    break;
                default:
                    contacts.push({ ...payload });
            }
            let fullPayload = {};
            fullPayload[this.contactsProperty] = [...contacts];

            axios
                .patch(`${this.endpoint}${this.person.id}`, fullPayload)
                .then(r => {
                    this.$emit("person-saved");
                    this.resetModal();
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped></style>
